export var Status;
(function (Status) {
    /** The restaurant can accommodate a party of the given size in this time slot. */
    Status["AVAILABLE"] = "AVAILABLE";
    /** The restaurant can't accommodate a party of the given size in this time slot. */
    Status["UNAVAILABLE"] = "UNAVAILABLE";
    /** The restaurant is not open during this time slot. Time slots retrieved by Get Scheduled Time Slots never have this status. */
    Status["NON_WORKING_HOURS"] = "NON_WORKING_HOURS";
})(Status || (Status = {}));
export var TableCombinationConflictType;
(function (TableCombinationConflictType) {
    /** Undefined conflict type. */
    TableCombinationConflictType["UNKNOWN"] = "UNKNOWN";
    /** One or more of the chosen tables are already reserved. */
    TableCombinationConflictType["RESERVED"] = "RESERVED";
    /** The party is too big for the selected table. */
    TableCombinationConflictType["TOO_BIG"] = "TOO_BIG";
    /** The party is too small for the selected table. */
    TableCombinationConflictType["TOO_SMALL"] = "TOO_SMALL";
    /** The restaurant does not allow online reservations. */
    TableCombinationConflictType["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(TableCombinationConflictType || (TableCombinationConflictType = {}));
export var Type;
(function (Type) {
    /** Undefined reservation location conflict type. */
    Type["UNKNOWN"] = "UNKNOWN";
    /** The restaurant cannot accommodate a party of the given size according to party pacing settings. */
    Type["PARTY_PACING"] = "PARTY_PACING";
    /** The required number of seats are unavailable according to seat pacing settings. */
    Type["SEAT_PACING"] = "SEAT_PACING";
})(Type || (Type = {}));
export var ExperienceTableCombinationConflictType;
(function (ExperienceTableCombinationConflictType) {
    /** Undefined conflict type. */
    ExperienceTableCombinationConflictType["UNKNOWN"] = "UNKNOWN";
    /** One or more of the chosen tables are already reserved. */
    ExperienceTableCombinationConflictType["RESERVED"] = "RESERVED";
    /** The party is too big for the selected table. */
    ExperienceTableCombinationConflictType["TOO_BIG"] = "TOO_BIG";
    /** The party is too small for the selected table. */
    ExperienceTableCombinationConflictType["TOO_SMALL"] = "TOO_SMALL";
})(ExperienceTableCombinationConflictType || (ExperienceTableCombinationConflictType = {}));
export var ExperienceConflictType;
(function (ExperienceConflictType) {
    /** Undefined reservation location conflict type. */
    ExperienceConflictType["UNKNOWN"] = "UNKNOWN";
    /** The number of guests exceeds the allowed limit. */
    ExperienceConflictType["MAXIMUM_NUMBER_OF_GUESTS"] = "MAXIMUM_NUMBER_OF_GUESTS";
})(ExperienceConflictType || (ExperienceConflictType = {}));
export var TimeSlotAvailabilityTimeSlotAvailabilityType;
(function (TimeSlotAvailabilityTimeSlotAvailabilityType) {
    TimeSlotAvailabilityTimeSlotAvailabilityType["UNKNOWN_TIME_SLOT_AVAILABILITY"] = "UNKNOWN_TIME_SLOT_AVAILABILITY";
    TimeSlotAvailabilityTimeSlotAvailabilityType["STANDARD"] = "STANDARD";
    TimeSlotAvailabilityTimeSlotAvailabilityType["EXPERIENCE"] = "EXPERIENCE";
})(TimeSlotAvailabilityTimeSlotAvailabilityType || (TimeSlotAvailabilityTimeSlotAvailabilityType = {}));
export var TableConflictType;
(function (TableConflictType) {
    TableConflictType["UNKNOWN"] = "UNKNOWN";
    TableConflictType["TABLE_RESERVED"] = "TABLE_RESERVED";
    TableConflictType["TABLE_TOO_BIG"] = "TABLE_TOO_BIG";
    TableConflictType["TABLE_TOO_SMALL"] = "TABLE_TOO_SMALL";
    TableConflictType["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(TableConflictType || (TableConflictType = {}));
export var TimeSlotAvailabilityType;
(function (TimeSlotAvailabilityType) {
    TimeSlotAvailabilityType["UNKNOWN_TIME_SLOT_AVAILABILITY"] = "UNKNOWN_TIME_SLOT_AVAILABILITY";
    TimeSlotAvailabilityType["STANDARD"] = "STANDARD";
    TimeSlotAvailabilityType["EXPERIENCE"] = "EXPERIENCE";
})(TimeSlotAvailabilityType || (TimeSlotAvailabilityType = {}));
//# sourceMappingURL=types.impl.js.map